import { createGlobalState } from 'react-hooks-global-state';

const STATE_KEYS = {
    IS_DEV: 'isDev',
    MAIN_VIEW: 'mainView',
    SHOW_TAB_BAR: 'showTabBar',
    LOGGED_IN: 'isLoggedIn',
    TRUCK_DATA: 'truckData',
    LOCATION_LIST: 'locationList',
    CURRENT_LOCATION_INDEX: 'currentLocationIndex',
    CURRENT_TAB_STACK: 'currentTabStack',
    LOADING_CONFIG: 'loadingConfig',
    ALERT_SHOWING: 'alertShowing',
    IN_SCREEN_MODAL_SHOWING: 'inScreenModalShowing',
    MENU_DATA: 'menuData',
    PAST_CATERING_LIST_OBJ: 'pastCateringListObj',
    PAST_HOOD_DATA: 'pastHoodData',
    CATERING_MENU_SAMPLES: 'cateringMenuSamples',
    TRIGGER_CATERING_RESPONDED: 'triggerCateringResponded',
    ACCOUNT_LIST: 'accountList',
    ACCOUNT_LIST_SELECTED_INDEX: 'accountListSelectedIndex',
    ADDING_NEW_ACCOUNT: 'addingNewAccount',
    DEEP_LINK_DATA: 'deepLinkData',
    DEEP_LINK_DATA_CATERING: 'deepLinkDataCatering',

    // Screen Keys
    CURRENT_SCREEN_KEY: 'currentScreenKey',
    PROFILE_SCREEN_KEY: 'currentProfileScreenKey',
    ALL_REVIEW_SCREEN_KEY: 'currentAllReviewScreenKey',
    CATERING_SCREEN_KEY: 'currentCateringScreenKey',
    PAST_CATERING_SCREEN_KEY: 'currentPastCateringScreenKey',
    PAST_HOOD_SCREEN_KEY: 'currentPastHoodScreenKey',
    ACCOUNT_SETTINGS_SCREEN_KEY: 'currentAccountSettingsScreenKey',

    // Trigger Keys
    PROFILE_REFRESH_TRIGGERED: 'profileRefreshTriggered'
};

export const initialGlobalState = {
    [STATE_KEYS.IS_DEV]: (process.env.REACT_APP_IS_DEV === 'true'),
    [STATE_KEYS.MAIN_VIEW]: null,
    [STATE_KEYS.SHOW_TAB_BAR]: true,
    [STATE_KEYS.LOGGED_IN]: false,
    [STATE_KEYS.TRUCK_DATA]: {},
    [STATE_KEYS.LOCATION_LIST]: [],
    [STATE_KEYS.CURRENT_LOCATION_INDEX]: 0,
    [STATE_KEYS.CURRENT_TAB_STACK]: 'Profile',
    [STATE_KEYS.LOADING_CONFIG]: null,
    [STATE_KEYS.ALERT_SHOWING]: false,
    [STATE_KEYS.IN_SCREEN_MODAL_SHOWING]: false,
    [STATE_KEYS.MENU_DATA]: [],
    [STATE_KEYS.PAST_CATERING_LIST_OBJ]: {},
    [STATE_KEYS.PAST_HOOD_DATA]: [],
    [STATE_KEYS.CATERING_MENU_SAMPLES]: { loaded: false, data: [] },
    [STATE_KEYS.TRIGGER_CATERING_RESPONDED]: null,
    [STATE_KEYS.ACCOUNT_LIST]: [],
    [STATE_KEYS.ACCOUNT_LIST_SELECTED_INDEX]: 0,
    [STATE_KEYS.ADDING_NEW_ACCOUNT]: false,
    [STATE_KEYS.DEEP_LINK_DATA]: { path: '', params: {} },
    [STATE_KEYS.DEEP_LINK_DATA_CATERING]: { goTo: '', openDetails: { isHood: false, dataID: 0 } },

    // Screen Keys
    [STATE_KEYS.CURRENT_SCREEN_KEY]: '',
    [STATE_KEYS.PROFILE_SCREEN_KEY]: null,
    [STATE_KEYS.ALL_REVIEW_SCREEN_KEY]: null,
    [STATE_KEYS.CATERING_SCREEN_KEY]: null,
    [STATE_KEYS.PAST_CATERING_SCREEN_KEY]: null,
    [STATE_KEYS.PAST_HOOD_SCREEN_KEY]: null,
    [STATE_KEYS.ACCOUNT_SETTINGS_SCREEN_KEY]: null,

    // Trigger Keys
    [STATE_KEYS.PROFILE_REFRESH_TRIGGERED]: false
}

const {
    setGlobalState,
    getGlobalState,
    useGlobalState
} = createGlobalState(initialGlobalState);

export {
    setGlobalState,
    getGlobalState,
    useGlobalState,
    STATE_KEYS
};
